import { render, staticRenderFns } from "./incentiveRecords.vue?vue&type=template&id=5af29a43&scoped=true"
import script from "./incentiveRecords.vue?vue&type=script&lang=js"
export * from "./incentiveRecords.vue?vue&type=script&lang=js"
import style0 from "./incentiveRecords.vue?vue&type=style&index=0&id=5af29a43&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af29a43",
  null
  
)

export default component.exports